const MAXIMUM_NEST_LEVEL = 3;

import {
  disabledCategoriesForNode,
  getAndOrOr,
  isQueryGroup,
} from '~/components/SearchBuilder/utils/nodeUtils';
import {
  getDependentCategory,
  getRootCategory,
  getService,
  isNodeExpanded,
  isThirdPartyNode,
} from '~/components/SearchBuilder/utils/thirdPartySearchUtils';

import styles from '../styles';
import QueryGroup from './QueryGroup';
import ThirdPartyQueryGroup from './QueryGroup/ThirdPartyQueryGroup';
import QueryNode from './QueryNode';

let StyledAnyQueryNode;

class AnyQueryNode extends React.Component {
  renderQueryGroup = (node) => {
    const { classes, search, onChange, attributes } = this.props;
    const andOrOr = getAndOrOr(node);

    return (
      <QueryGroup
        attributes={attributes}
        key={node.__index}
        className={classes.queryGroup}
        canAddGroup={node.__nest < MAXIMUM_NEST_LEVEL}
        node={node}
        onChange={onChange}
        search={search}>
        {node[andOrOr] &&
          node[andOrOr].map((node) => (
            <StyledAnyQueryNode
              {...this.props}
              key={node.__index}
              node={node}
            />
          ))}
      </QueryGroup>
    );
  };

  renderThirdPartyNode = (node) => {
    const { classes, type, onChange, attributes, search } = this.props;
    const dependentCategory = getDependentCategory(node, type);
    const rootCategory = getRootCategory(node);
    const service = getService(node);
    const expanded = isNodeExpanded(node);

    return (
      <ThirdPartyQueryGroup
        search={search}
        onChange={onChange}
        attributes={attributes}
        key={node.__index}
        className={classes.queryGroup}
        rootCategory={rootCategory}
        service={service}
        dependentCategory={dependentCategory}
        expanded={expanded}
        node={node}
      />
    );
  };

  render = () => {
    const { node, search, category } = this.props;

    let disabledCategories = disabledCategoriesForNode(search, node).filter(
      (_category) => _category !== category,
    );

    if (isQueryGroup(node)) {
      return this.renderQueryGroup(node);
    }

    if (isThirdPartyNode(node)) {
      return this.renderThirdPartyNode(node);
    }

    return (
      <QueryNode
        {...this.props}
        key={node.__index}
        node={node}
        search={search}
        disabledCategories={disabledCategories}
      />
    );
  };
}

AnyQueryNode.propTypes = {
  category: PropTypes.string,
  type: PropTypes.string,
  classes: PropTypes.object,
  search: PropTypes.object,
  onChange: PropTypes.func,
  attributes: PropTypes.array,
  node: PropTypes.object,
};

StyledAnyQueryNode = withStyles(styles)(AnyQueryNode);

export default StyledAnyQueryNode;
